import { WebshopCategoryDetail } from '@cldsystems/ws-api-client';
import { Filter, FilterOption } from '@/types/product-filter';
import { sortFilterOptions } from '@/utils/sort-filter-options';

export const createFilters = (category: WebshopCategoryDetail): Filter[] => {
  const filters = new Map<string, Filter>();

  const addOptionToFilter = (filter: Filter, value: string) => {
    if (!filter.options.some((opt: FilterOption) => opt.value === value)) {
      filter.options.push({ label: value, value: value });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const processOption = (option: any) => {
    if (option.isFilter) {
      if (!filters.has(option.key)) {
        filters.set(option.key, {
          id: option.key.charAt(0).toLowerCase() + option.key.slice(1),
          name: option.key,
          isInterval: false,
          isSearchField: false,
          options: [],
        });
      }

      const existingFilter = filters.get(option.key)!;
      option.values.forEach((value: string) => addOptionToFilter(existingFilter, value));
      existingFilter.isSearchField = existingFilter.options.length > 5;
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const processGroup = (group: any) => {
    group.options.forEach(processOption);
  };

  category?.attributeGroups?.forEach(processGroup);

  const sortedFilters = Array.from(filters.values())
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(filter => ({
      ...filter,
      options: sortFilterOptions(filter.id, filter.options),
    }));

  return sortedFilters;
};
